import * as R from "ramda";
const getDataflowDescription = (structure) => {
  const dataflow = R.pathOr({}, ["data", "dataflows", 0], structure);
  return R.propOr(null, "description", dataflow);
};
export {
  getDataflowDescription
};
